module.exports = __webpack_public_path__ + "static/media/iblu5.6351de31.jpg";